import React from "react";

/* The kit's report figure (.br-stat), not the classroom app's own tile.
   cls-tile put an icon in a tinted circle beside an oversized number and
   lifted itself 3px on hover -- card behaviour on something that is a
   readout. br-stat is label over figure with the tone as a 2px rule on
   the top edge, which is how a figure reads as a report rather than a
   poster.

   The icon goes: the label says what the number counts, and a glyph
   beside it only repeated the label in a second language. */
const TONE = {
  free: "br-stat--good",
  busy: "",
  crit: "br-stat--bad",
  warn: "br-stat--warn",
};

const StatTile = ({ num, label, variant, onClick }) => {
  const className = `br-stat ${TONE[variant] || ""}`.trim();

  /* A tile that does something is a button, so it says so and answers
     the keyboard; one that does not stays a plain box rather than a
     <button> with nothing behind it. */
  if (!onClick) {
    return (
      <div className={className}>
        <span className="br-stat-label">{label}</span>
        <span className="br-stat-value">{num}</span>
      </div>
    );
  }

  return (
    <button type="button" className={`${className} br-stat--act`} onClick={onClick}>
      <span className="br-stat-label">{label}</span>
      <span className="br-stat-value">{num}</span>
    </button>
  );
};

export default StatTile;
